import React from "react";
import LegalPage from "./LegalPage";

export default function Terms() {
  return (
    <LegalPage
      kicker="Legal"
      title="Terms & Conditions"
      updated="February 2026"
      testId="terms-page"
    >
      <p>
        These Terms &amp; Conditions ("Terms") govern your access to and use of LocalizeHER,
        operated by LocalizeHER ("LocalizeHER," "we," "us," or "our") at <strong>localizeher.com</strong>.
        By creating an account or using any part of the platform, you agree to these Terms.
      </p>

      <h2>1. Eligibility &amp; Account</h2>
      <p>
        You must be at least 18 years old and authorized to enter into a binding contract on behalf
        of yourself or your business. You are responsible for keeping your login credentials
        confidential and for all activity under your account.
      </p>

      <h2>2. What LocalizeHER Provides</h2>
      <p>
        LocalizeHER offers a marketing membership and community for women-owned local businesses,
        including the HER Guide directory, marketing education, events, journal content, and member
        community spaces. Some features are free; others require a paid membership.
      </p>

      <h2>3. Membership &amp; Payments</h2>
      <p>
        LocalizeHER is currently pre-launch and we are not processing membership payments at this
        time. Paid memberships are expected to launch in <strong>Summer 2026</strong>. When they
        do, billing terms (price, renewal, cancellation, refunds) will be presented at checkout
        and will form part of these Terms.
      </p>

      <h2>4. Member Content &amp; Directory Listings</h2>
      <p>
        You retain ownership of the content you submit (business name, description, logo, photos,
        social links). By submitting it you grant LocalizeHER a worldwide, royalty-free license to
        host, display, reproduce and promote it as part of operating the platform, the HER Guide
        directory, and our marketing channels (including social media). You confirm that you have
        all rights necessary in any content you submit and that it does not infringe any third
        party's rights.
      </p>

      <h2>5. Community Conduct</h2>
      <p>
        LocalizeHER is built on collaboration. You agree not to:
      </p>
      <ul>
        <li>Harass, threaten, or discriminate against another member;</li>
        <li>Post unlawful, deceptive, or misleading content;</li>
        <li>Use the platform for spam, MLM solicitation, or unauthorized commercial outreach;</li>
        <li>Attempt to access another member's account, scrape data, or reverse-engineer the platform.</li>
      </ul>
      <p>
        We may suspend or terminate accounts that violate these rules, without refund.
      </p>

      <h2>6. Intellectual Property</h2>
      <p>
        The LocalizeHER name, logo, "HER Guide" marks, written content, photography, design system,
        and code are owned by LocalizeHER or our licensors. You may not copy, redistribute, or
        create derivative works without our written permission.
      </p>

      <h2>7. Third-Party Services</h2>
      <p>
        We rely on trusted third parties to operate the platform — including Google (OAuth sign-in)
        and analytics providers. Your use of those features is also governed by their own terms.
      </p>

      <h2>8. Disclaimers</h2>
      <p>
        LocalizeHER is provided "as is" and "as available." We do not guarantee any specific
        business outcome (customers, revenue, search ranking, or otherwise). Educational content
        is general guidance — not legal, financial, or tax advice.
      </p>

      <h2>9. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, LocalizeHER's aggregate liability to you for any
        claim arising out of or relating to the platform is limited to the amount you paid us in the
        12 months preceding the claim. We are not liable for indirect, incidental, consequential,
        or lost-profits damages.
      </p>

      <h2>10. Indemnification</h2>
      <p>
        You agree to defend and indemnify LocalizeHER against claims arising from your content,
        your business activity promoted through the platform, or your violation of these Terms.
      </p>

      <h2>11. Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. If we make a material change, we'll notify
        active members by email or in-app message before it takes effect. Continued use after the
        effective date is acceptance of the updated Terms.
      </p>

      <h2>12. Governing Law &amp; Disputes</h2>
      <p>
        These Terms are governed by the laws of the <strong>State of Arizona</strong>, without
        regard to its conflict-of-laws rules. Any dispute will be resolved exclusively in the state
        or federal courts located in Maricopa County, Arizona, and you consent to that jurisdiction.
      </p>

      <h2>13. Contact</h2>
      <p>
        Questions about these Terms? Email <a href="mailto:hello@localizeher.com">hello@localizeher.com</a>.
      </p>

      <p style={{ marginTop: "2rem", fontSize: "0.85rem", color: "var(--lh-greige)" }}>
        <em>
          This document is a starting template and should be reviewed by an attorney licensed in
          Arizona before being held out as final legal terms.
        </em>
      </p>
    </LegalPage>
  );
}
